import { defineMessages } from 'react-intl';

export default defineMessages({
  thisSectionRelatedToMedicalExpenses: {
    id: 'fastCover.standardVTCMedicalBenefits.thisSectionRelatedToMedicalExpenses',
    defaultMessage: 'The section relates to medical expenses such as doctors visits, prescriptions or hospitalizations and similar services.',
  },
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.standardVTCMedicalBenefits.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  isRequired: {
    id: 'fastCover.standardVTCMedicalBenefits.isRequired',
    defaultMessage: '{defaultMessage} is required',
  },
  yes: {
    id: 'fastCover.standardVTCMedicalBenefits.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.standardVTCMedicalBenefits.no',
    defaultMessage: 'No',
  },
  checkboxDoctorVisit: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxDoctorVisit',
    defaultMessage: "Doctor's Visit",
  },
  questionDidYouHaveYourVisitByTelephoneOrVideoCall: {
    id: 'fastCover.standardVTCMedicalBenefits.questionDidYouHaveYourVisitByTelephoneOrVideoCall',
    defaultMessage: 'Did you have your visit by telephone or video call?',
  },
  headerTelemedicineBenefit: {
    id: 'fastCover.standardVTCMedicalBenefits.headerTelemedicineBenefit',
    defaultMessage: 'Telemedicine Benefit',
  },
  questionFirstVisitIllnessAccident: {
    id: 'fastCover.standardVTCMedicalBenefits.questionFirstVisitIllnessAccident',
    defaultMessage: 'Is this the first visit for the illness/accident?',
  },
  headerOutpatientPhysicianFees: {
    id: 'fastCover.standardVTCMedicalBenefits.headerOutpatientPhysicianFees',
    defaultMessage: 'Outpatient Physician Fees',
  },
  questionFollowUpVisit: {
    id: 'fastCover.standardVTCMedicalBenefits.questionFollowUpVisit',
    defaultMessage: 'Is this a follow up visit for a previously claimed illness or accident other than a fracture?',
  },
  headerFollowUpVisit: {
    id: 'fastCover.standardVTCMedicalBenefits.headerFollowUpVisit',
    defaultMessage: 'Follow Up Visit',
  },
  questionFollowUpVisitFracture: {
    id: 'fastCover.standardVTCMedicalBenefits.questionFollowUpVisitFracture',
    defaultMessage: 'Is this a follow up visit for a fracture?',
  },
  headerFractureTreatment: {
    id: 'fastCover.standardVTCMedicalBenefits.headerFractureTreatment',
    defaultMessage: 'Fracture Treatment',
  },
  tooltipFractureTreatment: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipFractureTreatment',
    defaultMessage: 'Please provide details of the fracture treatment expenses.',
  },
  noOngoingCareMessage: {
    id: 'fastCover.standardVTCMedicalBenefits.noOngoingCareMessage',
    defaultMessage: 'We do not cover visits for ongoing care. Please refer to your policy document for further detail.',
  },
  addItem: {
    id: 'fastCover.standardVTCMedicalBenefits.addItem',
    defaultMessage: 'Add Expense',
  },
  descriptionOfExpense: {
    id: 'fastCover.standardVTCMedicalBenefits.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpense: {
    id: 'fastCover.standardVTCMedicalBenefits.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  amountClaimed: {
    id: 'fastCover.standardVTCMedicalBenefits.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.standardVTCMedicalBenefits.currency',
    defaultMessage: 'Currency',
  },
  providerName: {
    id: 'fastCover.standardVTCMedicalBenefits.providerName',
    defaultMessage: 'Provider Name',
  },
  checkEventDate: {
    id: 'fastCover.standardVTCMedicalBenefits.checkEventDate',
    defaultMessage: '{defaultMessage} is not a valid date',
  },
  expenseFor: {
    id: 'fastCover.standardVTCMedicalBenefits.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.standardVTCMedicalBenefits.selectInsuredForExpense',
    defaultMessage: 'Please select the insured(s) for this expense',
  },

  // Diagnostic Tests
  checkboxDiagnosticTests: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },
  headerDiagnosticTests: {
    id: 'fastCover.standardVTCMedicalBenefits.headerDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },

  // Prescription Drugs
  checkboxPrescriptionDrugs: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },
  headerPrescriptionDrugs: {
    id: 'fastCover.standardVTCMedicalBenefits.headerPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },

  // Ambulance Services
  checkboxAmbulanceServices: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxAmbulanceServices',
    defaultMessage: 'Ambulance Services',
  },
  questionGroundAmbulance: {
    id: 'fastCover.standardVTCMedicalBenefits.questionGroundAmbulance',
    defaultMessage: 'Is your invoice for a ground ambulance?',
  },
  headerGroundAmbulance: {
    id: 'fastCover.standardVTCMedicalBenefits.headerGroundAmbulance',
    defaultMessage: 'Ground Ambulance',
  },
  questionAirAmbulance: {
    id: 'fastCover.standardVTCMedicalBenefits.questionAirAmbulance',
    defaultMessage: 'Is your invoice for an Air Ambulance?',
  },
  headerAirAmbulance: {
    id: 'fastCover.standardVTCMedicalBenefits.headerAirAmbulance',
    defaultMessage: 'Air Ambulance',
  },
  headerOtherAmbulance: {
    id: 'fastCover.standardVTCMedicalBenefits.headerOtherAmbulance',
    defaultMessage: 'Other Types of Ambulances',
  },

  // Hospitalization
  checkboxHospitalization: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxHospitalization',
    defaultMessage: 'Hospitalization',
  },
  headerHospitalFees: {
    id: 'fastCover.standardVTCMedicalBenefits.headerHospitalFees',
    defaultMessage: 'Hospital Fees',
  },
  headerInpatientPhysicianFees: {
    id: 'fastCover.standardVTCMedicalBenefits.headerInpatientPhysicianFees',
    defaultMessage: 'Physician Fees while hospitalized',
  },
  headerXrayLabsDiagnostics: {
    id: 'fastCover.standardVTCMedicalBenefits.headerXrayLabsDiagnostics',
    defaultMessage: 'Expenses for X-Ray, Labs, or other diagnostics while hospitalized',
  },
  headerEmergencyAirTransportation: {
    id: 'fastCover.standardVTCMedicalBenefits.headerEmergencyAirTransportation',
    defaultMessage: 'Emergency Air Transportation that was approved by us in advance',
  },
  headerAirfareReturnHome: {
    id: 'fastCover.standardVTCMedicalBenefits.headerAirfareReturnHome',
    defaultMessage: 'Airfare to Return Home For Treatment Benefit that was approved by us in advance',
  },
  headerFamilyTransportation: {
    id: 'fastCover.standardVTCMedicalBenefits.headerFamilyTransportation',
    defaultMessage: 'Family Transportation expenses approved by us in advance',
  },
  headerFamilyTransportationMealsAccommodation: {
    id: 'fastCover.standardVTCMedicalBenefits.headerFamilyTransportationMealsAccommodation',
    defaultMessage: 'Family Transportation Meals and accommodation costs approved by us in advance',
  },
  headerMedicalAttendant: {
    id: 'fastCover.standardVTCMedicalBenefits.headerMedicalAttendant',
    defaultMessage: 'Medical Attendant that was approved by us in advance',
  },
  tooltipMedicalAttendant: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipMedicalAttendant',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit or the Airfare to Return Home for treatment benefit.',
  },
  headerReturnOfTravellingCompanion: {
    id: 'fastCover.standardVTCMedicalBenefits.headerReturnOfTravellingCompanion',
    defaultMessage: 'Return of Travelling Companion that was approved by us in advance',
  },
  tooltipReturnOfTravellingCompanion: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipReturnOfTravellingCompanion',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit, the Airfare to Return Home for treatment benefit, or the Repatriation benefit.',
  },
  headerReturnOfDependentChildren: {
    id: 'fastCover.standardVTCMedicalBenefits.headerReturnOfDependentChildren',
    defaultMessage: 'Return of Dependent Children that was approved by us in advance',
  },
  tooltipReturnOfDependentChildren: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipReturnOfDependentChildren',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit, the Airfare to Return Home for treatment benefit, or the Repatriation benefit.',
  },
  headerHospitalAllowance: {
    id: 'fastCover.standardVTCMedicalBenefits.headerHospitalAllowance',
    defaultMessage: 'Hospital allowance',
  },
  tooltipHospitalAllowance: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipHospitalAllowance',
    defaultMessage: 'Up to $100 per day to cover TV rental or telephone charges which are billed by the hospital',
  },
  headerOutOfPocketExpenses: {
    id: 'fastCover.standardVTCMedicalBenefits.headerOutOfPocketExpenses',
    defaultMessage: 'Out-Of-Pocket Expenses',
  },
  tooltipOutOfPocketExpenses: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipOutOfPocketExpenses',
    defaultMessage: 'Up to $500 per day to a maximum of $5,000 for your commercial accommodation, meals, telephone calls, internet charges, taxi fare, parking charges, bus fare and rental car under the circumstances listed in your policy document',
  },
  headerChildcare: {
    id: 'fastCover.standardVTCMedicalBenefits.headerChildcare',
    defaultMessage: 'Childcare',
  },
  tooltipChildcare: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipChildcare',
    defaultMessage: 'Up to $500 per day to a maximum of $5,000 for child care costs for insured children 18 years and under who are travelling with you (excluding child care provided by a family member) when you are hospitalized.',
  },
  headerReturnOfVehicle: {
    id: 'fastCover.standardVTCMedicalBenefits.headerReturnOfVehicle',
    defaultMessage: 'Return of Vehicle',
  },
  tooltipReturnOfVehicle: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipReturnOfVehicle',
    defaultMessage: 'Payable only when pre-approved by TuGo when a doctor determines you are incapable of continuing your trip by vehicle.',
  },
  headerReturnOfVehicleCommercialAgency: {
    id: 'fastCover.standardVTCMedicalBenefits.headerReturnOfVehicleCommercialAgency',
    defaultMessage: 'Charges for a commercial agency to return an owned or rented vehicle',
  },
  headerReturnOfVehicleFamilyMemberFriend: {
    id: 'fastCover.standardVTCMedicalBenefits.headerReturnOfVehicleFamilyMemberFriend',
    defaultMessage: 'Airfare, gas, meals and/or accommodation related to your family member or friend returning your vehicle.',
  },
  headerOtherHospitalizationRelated: {
    id: 'fastCover.standardVTCMedicalBenefits.headerOtherHospitalizationRelated',
    defaultMessage: 'Other expenses related to hospitalization',
  },

  // Essential Medical Equipment
  checkboxEssentialMedicalEquipment: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxEssentialMedicalEquipment',
    defaultMessage: 'Essential Medical Equipment',
  },
  tooltipEssentialMedicalEquipment: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipEssentialMedicalEquipment',
    defaultMessage: 'Expenses related to the cost of renting essential medical equipment such as crutches or wheelchair.',
  },
  headerEssentialMedicalEquipment: {
    id: 'fastCover.standardVTCMedicalBenefits.headerEssentialMedicalEquipment',
    defaultMessage: 'Essential Medical Equipment',
  },

  // Private Duty Nursing
  checkboxPrivateDutyNursing: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },
  tooltipPrivateDutyNursing: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipPrivateDutyNursing',
    defaultMessage: 'Private duty nursing must be performed by an RN other than a family member when ordered in writing by the attending physician.',
  },
  headerPrivateDutyNursing: {
    id: 'fastCover.standardVTCMedicalBenefits.headerPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },

  // Fracture Treatment (standalone checkbox)
  checkboxFractureTreatmentStandalone: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxFractureTreatmentStandalone',
    defaultMessage: 'Fracture Treatment',
  },
  tooltipFractureTreatmentStandalone: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipFractureTreatmentStandalone',
    defaultMessage: 'This can include the cost of x-rays, reexamination by a physician, casting, re-casting and cast removal. Fracture benefit does not apply if you have claimed Airfare to Return Home for Treatment.',
  },
  headerFractureTreatmentStandalone: {
    id: 'fastCover.standardVTCMedicalBenefits.headerFractureTreatmentStandalone',
    defaultMessage: 'Fracture Treatment',
  },

  // Maternity Benefits
  checkboxMaternityBenefits: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxMaternityBenefits',
    defaultMessage: 'Maternity Benefits',
  },
  dateOfConception: {
    id: 'fastCover.standardVTCMedicalBenefits.dateOfConception',
    defaultMessage: 'Please enter the date of conception:',
  },
  dateOfConceptionTooltip: {
    id: 'fastCover.standardVTCMedicalBenefits.dateOfConceptionTooltip',
    defaultMessage: 'Conception means the date your pregnancy began, not when you discovered you were pregnant',
  },
  anticipatedDueDate: {
    id: 'fastCover.standardVTCMedicalBenefits.anticipatedDueDate',
    defaultMessage: 'Please enter your anticipated due date:',
  },
  headerRoutinePreNatalCare: {
    id: 'fastCover.standardVTCMedicalBenefits.headerRoutinePreNatalCare',
    defaultMessage: 'Routine Pre-Natal Care',
  },
  headerComplicationsOfPregnancy: {
    id: 'fastCover.standardVTCMedicalBenefits.headerComplicationsOfPregnancy',
    defaultMessage: 'Complications of Pregnancy',
  },

  // Dental Services
  checkboxDentalServices: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxDentalServices',
    defaultMessage: 'Dental Services',
  },
  dentalServicesDentalAccident: {
    id: 'fastCover.standardVTCMedicalBenefits.dentalServicesDentalAccident',
    defaultMessage: 'Dental Accident (result of a blow to the face)',
  },
  dentalServicesDentalPainOther: {
    id: 'fastCover.standardVTCMedicalBenefits.dentalServicesDentalPainOther',
    defaultMessage: 'Dental pain other than accident',
  },
  headerDentalAccident: {
    id: 'fastCover.standardVTCMedicalBenefits.headerDentalAccident',
    defaultMessage: 'Dental Accident',
  },
  headerDentalPain: {
    id: 'fastCover.standardVTCMedicalBenefits.headerDentalPain',
    defaultMessage: 'Dental Pain',
  },

  // Professional Services
  checkboxProfessionalServices: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxProfessionalServices',
    defaultMessage: 'Professional Services',
  },
  professionalServicesDescription: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesDescription',
    defaultMessage: 'These benefits are only eligible when they are ordered by a physician at the time of, and as a result of your emergency.',
  },
  professionalServicesPhysiotherapist: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesPhysiotherapist',
    defaultMessage: 'Physiotherapist',
  },
  professionalServicesChiropractor: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesChiropractor',
    defaultMessage: 'Chiropractor',
  },
  professionalServicesChiropodist: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesChiropodist',
    defaultMessage: 'Chiropodist',
  },
  professionalServicesOsteopath: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesOsteopath',
    defaultMessage: 'Osteopath',
  },
  professionalServicesPodiatrist: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesPodiatrist',
    defaultMessage: 'Podiatrist',
  },
  professionalServicesAcupuncturist: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesAcupuncturist',
    defaultMessage: 'Acupuncturist',
  },
  professionalServicesOptometrist: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesOptometrist',
    defaultMessage: 'Optometrist',
  },
  professionalServicesSelectOneRequired: {
    id: 'fastCover.standardVTCMedicalBenefits.professionalServicesSelectOneRequired',
    defaultMessage: 'Please select at least one professional service or uncheck Professional Services.',
  },

  // Accidental Death and Dismemberment Benefits
  checkboxAccidentalDeathAndDismembermentBenefits: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxAccidentalDeathAndDismembermentBenefits',
    defaultMessage: 'Accidental Death and Dismemberment Benefits',
  },
  headerAccidentalDeathAndDismemberment24HourAccident: {
    id: 'fastCover.standardVTCMedicalBenefits.headerAccidentalDeathAndDismemberment24HourAccident',
    defaultMessage: '24 Hour Accident',
  },
  tooltipAccidentalDeathAndDismemberment24HourAccident: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipAccidentalDeathAndDismemberment24HourAccident',
    defaultMessage:
      'Death or dismemberment as a result of an accident sustained during the period of coverage while riding as a fare-paying passenger, or while entering or leaving a lawfully operated licensed common carrier. Coverage is also applicable to insured children under two years accompanied by a fare paying passenger.',
  },

  // Expenses Related to Death (Standard VTC Medical Benefits)
  checkboxExpensesRelatedToDeath: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxExpensesRelatedToDeath',
    defaultMessage: 'Expenses Related to Death',
  },
  tooltipExpensesRelatedToDeath: {
    id: 'fastCover.standardVTCMedicalBenefits.tooltipExpensesRelatedToDeath',
    defaultMessage:
      'Expenses related to death are payable only when pre-approved by us. Charges for funeral expenses, coffin or urn are not eligible for reimbursement.',
  },
  headerExpensesRelatedToDeathReturnOfRemains: {
    id: 'fastCover.standardVTCMedicalBenefits.headerExpensesRelatedToDeathReturnOfRemains',
    defaultMessage: 'Return of remains to home country',
  },
  headerExpensesRelatedToDeathBurialOrCremationAtPlaceOfDeath: {
    id: 'fastCover.standardVTCMedicalBenefits.headerExpensesRelatedToDeathBurialOrCremationAtPlaceOfDeath',
    defaultMessage: 'Burial or Cremation at Place of Death',
  },
  headerExpensesRelatedToDeathTransportationOfFamilyMemberToIdentifyBody: {
    id: 'fastCover.standardVTCMedicalBenefits.headerExpensesRelatedToDeathTransportationOfFamilyMemberToIdentifyBody',
    defaultMessage: 'Transportation of Family Member to Identify Remains when required',
  },
  checkboxOtherUnrelatedBenefit: {
    id: 'fastCover.standardVTCMedicalBenefits.checkboxOtherUnrelatedBenefit',
    defaultMessage: 'Other (unrelated to any benefit listed above)',
  },
  headerOtherUnrelatedBenefit: {
    id: 'fastCover.standardVTCMedicalBenefits.headerOtherUnrelatedBenefit',
    defaultMessage: 'Other (unrelated to any benefit listed above)',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StandardVTCMedicalBenefits/messages.js